import { render, staticRenderFns } from "./multiple-choice.vue?vue&type=template&id=0628259f&"
import script from "./multiple-choice.vue?vue&type=script&lang=ts&"
export * from "./multiple-choice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports